import { useEffect, useState } from 'react';

const doesWindowExist = typeof window !== 'undefined';

function useLocalStorage<T>(storageKey: string, initialState: T) {
    const [state, setInternalState] = useState<T>(() => {
        // Use a function to initialize the state to avoid calling localStorage on SSR.
        const storageInBrowser = doesWindowExist
            ? localStorage.getItem(storageKey)
            : null;
        return storageInBrowser ? JSON.parse(storageInBrowser) : initialState;
    });

    useEffect(() => {
        // Save the data to the store when the state changes.
        if (doesWindowExist) {
            localStorage.setItem(storageKey, JSON.stringify(state));
        }
    }, [state, storageKey]);

    return [state, setInternalState] as const;
}

export default useLocalStorage;
